import {SubProduct, Vertical} from "@bounce/shared/consumer/declarations";

type DebtHeaderInput = {
  vertical?: Vertical | null;
  subProduct?: SubProduct | null;
  partnerMarketingName?: string;
};

type DebtHeader = {
  title: string;
  subtitle?: string;
  hasSubProduct: boolean;
};

export const getSubProductTitle = (subProduct?: SubProduct | null) =>
  subProduct?.display_marketing_name || subProduct?.marketing_name || "";

export const getDebtHeader = ({vertical, subProduct, partnerMarketingName = ""}: DebtHeaderInput): DebtHeader => {
  const subProductTitle = vertical ? getSubProductTitle(subProduct) : "";
  if (!subProductTitle) return {title: partnerMarketingName, hasSubProduct: false};
  return {
    title: subProductTitle,
    subtitle: partnerMarketingName ? `Issued by ${partnerMarketingName}` : undefined,
    hasSubProduct: true,
  };
};
